import { getValue } from '../../utils/tools'
const strReg = /^￥/
// 转成数字
export const toNumber = num => {
  // 如果是人民币的形式, 先去掉￥ 然后在转数字
  if (strReg.test(num)) {
    num = num.substr(1).replace(',', '')
  }
  return isNaN(+num) ? 0 : +num
}

function riseOrDownSort (arr, key, sortType, order) {
  let result = [...arr]
  const isDown = order === 'descending'
  let sortFn = (a, b) => {
    const _c = getValue(key, a)
    const _d = getValue(key, b)
    let c = typeof _c === 'number' ? _c : (_c || '')
    let d = typeof _d === 'number' ? _d : (_d || '')
    if ((sortType && sortType === 'number') || typeof c === 'number') {
      return isDown ? toNumber(d) - toNumber(c) : toNumber(c) - toNumber(d)
    }
    return isDown ? String(d).localeCompare(c, 'zh') : String(c).localeCompare(d, 'zh')
  }
  result.sort(sortFn)
  return result
}

export function sortData(formatDataResult, { store } = {}) {
  const { sortMap } = store.states
  const { order, prop, sortMethod, sortType, sortable } = sortMap
  if (!sortMap || sortable !== true) return formatDataResult
  let result
  if (sortMethod && typeof sortMethod === 'function') {
   result = sortMethod([...formatDataResult.tableData], prop, order)
  } else if (prop && order) {
   result = riseOrDownSort(formatDataResult.tableData, prop, sortType, order)
  } else {
    return formatDataResult
  }
  return {
    ...formatDataResult,
    tableData: result
  }
}

export const sortMethods = {
  localSort (column) {
    const { sortMethod, key, sortCompare, sortType } = column
    const order = this.states.sortMap.order
    const prop = key
    this.states.sortMap = {
      prop,
      order,
      sortMethod,
      sortCompare,
      sortable: true,
      sortType
    }
    this.updateTableData()
  },
  sortChange (column) {
    if (!this.states.renderData.length) {
      return
    }
    const { sortable, sortKeys, key, sortType } = column
    let remoteSort = sortKeys && sortKeys.length === 2
    if (!this.states.sortMap.order) {
      // 设置表头排序的默认排序方向，首次点击后排序方向
      this.states.sortMap.order = this.table.$props.defaultClickSortOrder === 'descending' ? 'descending' : 'ascending'
    } else {
      this.states.sortMap.order = this.states.sortMap.order === 'ascending' ? 'descending' : 'ascending'
    }
    this.states.sortMap.prop = key
    this.states.sortMap.sortable = sortable
    this.states.sortMap.sortType = sortType
    const order = this.states.sortMap.order
    const prop = key
    if (sortable === 'custom' || remoteSort) {
      this.table.$emit('sort-change', {
        remote: true,
        column,
        prop,
        order
      })
    } else if (sortable) {
      this.localSort(column)
      this.table.$emit('sort-change', {
        remote: false,
        column,
        prop,
        order
      })
    }
  },
  clearSort () {
    this.states.sortMap = {}
    this.table.$emit('sort-change', {})
  }
}

export default {
  data () {
    return {
      states: {
        sortMap: {
          order: '',
          prop: ''
        }, // 排序
      }
    }
  },
  methods: sortMethods,
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/sortable.js